export default __webpack_public_path__ + "static/media/rain.3fd7f41d.svg";